import ProfileImage from './ProfileImage.js';
import { helpers } from '../services/helpers';

function ProfileHover({ profile, onClose }) {
  return (
    <div className="profile-hover-container">
      <ProfileImage profile={profile} size={80} />
      <div style={{ display: 'flex', flexDirection: 'column', paddingLeft: '0.5rem' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <span className="profile-hover-name">{profile.username}</span>
          <button className="profile-hover-close-btn" style={{ boxSizing: 'inherit' }} onClick={onClose}>
            ×
          </button>
        </div>
        <div style={{ paddingTop: '0.5rem', textAlign: 'left' }}>
          Member since <span style={{ fontWeight: 'bold' }}>{helpers.englishDate(profile.createdAt)}</span>
        </div>
        <div style={{ paddintTop: '0.5rem', fontWeight: 'bold', textAlign: 'left' }}>
          {profile.surgeryCount} {profile.surgeryCount == 1 ? 'Surgery' : 'Surgeries'}
        </div>
        {(profile.surgeryCount > 0) && (
          <a style={{ marginTop: '0.5rem', textAlign: 'left', width: "100%" }} href={`/surgeries?user=${profile.id}`}>
            <button className="continue-button" style={{ padding: '0.5rem', width: "100%", fontWeight: "bold" }}>Show {profile.surgeryCount == 1 ? 'Surgery' : 'Surgeries'}</button>
          </a>
        )}
        {(profile.painDiaryPublic) && (
          <a style={{ marginTop: '0.5rem', textAlign: 'left', width: "100%" }} href={`/diary/${profile.id}`}>
            {/* TODO: MAKE HEADER BUTTONS LOOK LIKE THESE */}
            <button className="continue-button" style={{ padding: '0.5rem', width: "100%", fontWeight: "bold" }}>Pain Diary</button>
          </a>
        )}
      </div>
    </div>
  );
}

export default ProfileHover;
